import { InjectionToken } from '@angular/core';

export const CAPTURUM_BUILDERS_CONFIG_STORAGE_PROVIDERS = new InjectionToken<Record<string, string>>('Capturum builder config storage providers');
